import * as yup from "yup";
import { Form } from "@/components/organisms/Form";
import { request } from "@/common/api";
import { useForm } from "react-hook-form";
import { Buttons } from "@/components/atoms/Buttons";
import { useState } from "react";
import { showAlert } from "@/components/containers/Alert";
import { useNavigate } from "react-router";
import { useMutation } from "@tanstack/react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import { TextControl } from "@/components/containers/Controls/TextControl";
import { BaseResponse } from "@/common/types/baseRespones";
import { FormInputBox } from "@/components/molecules/FormInputBox";
import { SelectControl } from "@/components/containers/Controls/SelectControl";
import { FindAccountTemplate } from "@/components/templates/FindAccountTemplate";

const schema = yup.object({
  user: yup.object({
    userId: yup.string().required("아이디는 필수 입력입니다."),
    questionAnswer: yup.string().required("질문 답변은 필수 입력입니다."),
    accountFindQuestion: yup.string().required("질문 선택은 필수 입력입니다."),
  }),
});

export const FindPwPage = () => {
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm({
    resolver: yupResolver(schema),
  });
  const [findQusetion, setFindQuestion] = useState<string>("");

  const { mutateAsync: findPw } = useMutation({
    mutationFn: (data: {
      userId: string;
      accountFindQuestion: string;
      questionAnswer: string;
    }) => {
      return request<BaseResponse>({
        method: "POST",
        url: "/auth/find-password",
        data,
      });
    },
    onSuccess: (res) => {
      if (!res.success) {
        showAlert(`${res.message}`);
        return;
      }

      navigate("/auth/account/change-password", {
        state: {
          userData: res.data,
        },
      });
    },
  });

  const onSubmit = (data: any) => {
    findPw({
      userId: data.user.userId,
      questionAnswer: data.user.questionAnswer,
      accountFindQuestion: data.user.accountFindQuestion,
    });
  };

  return (
    <FindAccountTemplate>
      <Form
        title="가입정보 입력"
        submitBtn={
          <Buttons
            type="submit"
            size="lg"
            color="primary100"
            layout="solid"
            label="비밀번호 찾기"
          />
        }
        onSubmit={handleSubmit(onSubmit)}
      >
        <FormInputBox>
          <>
            <TextControl
              control={control}
              name="user.userId"
              label="아이디"
              placeholder="아이디를 입력하세요."
              required={true}
            />
            <SelectControl
              name="user.accountFindQuestion"
              control={control}
              placeholder="계정 찾기 질문을 선택하세요."
              required={true}
              value={findQusetion}
              onChange={setFindQuestion}
              label="계정 찾기 질문"
              options={[
                {
                  label: "할아버지의 성함은 무엇인가요?",
                  value: "grandFather",
                },
                {
                  label: "할머니의 성함은 무엇인가요?",
                  value: "grandMa",
                },
                { label: "아버지의 성함은 무엇인가요?", value: "father" },
                { label: "어머니의 성함은 무엇인가요?", value: "mother" },
              ]}
            />
            <TextControl
              control={control}
              name="user.questionAnswer"
              label="질문 답변"
              placeholder="질문에 답변을 입력하세요."
              required={true}
            />
          </>
        </FormInputBox>
      </Form>
    </FindAccountTemplate>
  );
};
